"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importDefault(require("react"));
const uuid_1 = __importDefault(require("uuid"));
const immer_1 = __importDefault(require("immer"));
const immer_2 = require("immer");
const expressions_1 = require("@mwater/expressions");
const Chart_1 = __importDefault(require("../Chart"));
const expressions_2 = require("@mwater/expressions");
const AxisBuilder_1 = __importDefault(require("../../../axes/AxisBuilder"));
const TextWidget_1 = __importDefault(require("../../text/TextWidget"));
const PivotChartUtils = __importStar(require("./PivotChartUtils"));
const PivotChartQueryBuilder_1 = __importDefault(require("./PivotChartQueryBuilder"));
const PivotChartLayoutBuilder_1 = __importDefault(require("./PivotChartLayoutBuilder"));
const ExprItemsTranslator_1 = require("../../../richtext/ExprItemsTranslator");
// Store true as a weakly cached value if a design is already clean
const cleanDesignCache = new expressions_1.WeakCache();
class PivotChart extends Chart_1.default {
    cleanDesign(design, schema) {
        const exprCleaner = new expressions_2.ExprCleaner(schema);
        const axisBuilder = new AxisBuilder_1.default({ schema });
        // Use weak caching to improve performance of cleaning complex pivot charts
        if (cleanDesignCache.get([design, schema], []) === true) {
            return design;
        }
        const cleanedDesign = (0, immer_1.default)(design, (draft) => {
            // Fill in defaults
            draft.version = design.version || 1;
            draft.rows = design.rows || [];
            draft.columns = design.columns || [];
            draft.intersections = design.intersections || {};
            draft.header = design.header || { style: "header", items: [] };
            draft.footer = design.footer || { style: "footer", items: [] };
            // Fix style of header
            draft.header.style = "header";
            if (design.table) {
                // Add default row and column
                let intersectionId, segment;
                if (draft.rows.length === 0) {
                    draft.rows.push({ id: (0, uuid_1.default)() });
                }
                if (draft.columns.length === 0) {
                    draft.columns.push({ id: (0, uuid_1.default)() });
                }
                // Cleans a single segment
                const cleanSegment = (segment) => {
                    if (segment.valueAxis) {
                        segment.valueAxis = axisBuilder.cleanAxis({
                            axis: segment.valueAxis ? (0, immer_2.original)(segment.valueAxis) : null,
                            table: design.table,
                            aggrNeed: "none",
                            types: ["enum", "enumset", "text", "boolean", "date"]
                        });
                    }
                    // Remove valueLabelBold if no valueAxis
                    if (!segment.valueAxis) {
                        delete segment.valueLabelBold;
                    }
                    if (segment.filter) {
                        segment.filter = exprCleaner.cleanExpr(segment.filter ? (0, immer_2.original)(segment.filter) : null, {
                            table: design.table,
                            types: ["boolean"]
                        });
                    }
                    if (segment.orderExpr) {
                        segment.orderExpr = exprCleaner.cleanExpr(segment.orderExpr ? (0, immer_2.original)(segment.orderExpr) : null, {
                            table: design.table,
                            aggrStatuses: ["aggregate"],
                            types: ["enum", "text", "boolean", "date", "datetime", "number"]
                        });
                    }
                };
                // Clean all segments
                for (segment of PivotChartUtils.getAllSegments(draft.rows)) {
                    cleanSegment(segment);
                }
                for (segment of PivotChartUtils.getAllSegments(draft.columns)) {
                    cleanSegment(segment);
                }
                // Clean all intersections
                for (intersectionId in draft.intersections) {
                    const intersection = draft.intersections[intersectionId];
                    const intersectionTable = intersection.tableOverride || design.table;
                    if (intersection.valueAxis) {
                        intersection.valueAxis = axisBuilder.cleanAxis({
                            axis: intersection.valueAxis ? (0, immer_2.original)(intersection.valueAxis) : null,
                            table: intersectionTable,
                            aggrNeed: "required",
                            types: ["enum", "text", "boolean", "date", "number"]
                        });
                    }
                    if (intersection.backgroundColorAxis) {
                        intersection.backgroundColorAxis = axisBuilder.cleanAxis({
                            axis: intersection.backgroundColorAxis ? (0, immer_2.original)(intersection.backgroundColorAxis) : null,
                            table: intersectionTable,
                            aggrNeed: "required",
                            types: ["enum", "text", "boolean", "date"]
                        });
                        if (intersection.backgroundColorOpacity == null) {
                            intersection.backgroundColorOpacity = 1;
                        }
                    }
                    for (const colorCondition of intersection.backgroundColorConditions || []) {
                        colorCondition.condition = exprCleaner.cleanExpr(colorCondition.condition ? (0, immer_2.original)(colorCondition.condition) : null, {
                            table: intersectionTable,
                            types: ["boolean"],
                            aggrStatuses: ["aggregate", "literal"]
                        });
                    }
                    if (intersection.filter) {
                        intersection.filter = exprCleaner.cleanExpr(intersection.filter ? (0, immer_2.original)(intersection.filter) : null, {
                            table: intersectionTable,
                            types: ["boolean"]
                        });
                    }
                    if (intersection.tableOverride) {
                        const allSegments = PivotChartUtils.getAllSegments(design.rows).concat(PivotChartUtils.getAllSegments(design.columns));
                        // Clean segment value axis overrides
                        intersection.segmentValueAxisOverrides = intersection.segmentValueAxisOverrides || {};
                        for (const segmentId of Object.keys(intersection.segmentValueAxisOverrides)) {
                            // Find segment
                            const segment = allSegments.find((s) => s.id === segmentId);
                            if (!segment || !segment.valueAxis) {
                                delete intersection.segmentValueAxisOverrides[segmentId];
                                continue;
                            }
                            // Get type of the segment
                            const segmentValueAxisType = axisBuilder.getAxisType(segment.valueAxis);
                            intersection.segmentValueAxisOverrides[segmentId] = axisBuilder.cleanAxis({
                                axis: intersection.segmentValueAxisOverrides[segmentId] ? (0, immer_2.original)(intersection.segmentValueAxisOverrides[segmentId]) : null,
                                table: intersectionTable,
                                aggrNeed: "none",
                                types: [segmentValueAxisType]
                            });
                        }
                        // Determine all required segment overrides
                        const intersectingSegmentIds = intersectionId.split(/[,:]/).filter(id => id !== "");
                        const intersectingSegments = allSegments.filter(segment => intersectingSegmentIds.includes(segment.id) && segment.valueAxis);
                        intersection.segmentValueAxisOverridesComplete = intersectingSegments.every(segment => intersection.segmentValueAxisOverrides[segment.id]);
                    }
                    else {
                        delete intersection.segmentValueAxisOverridesComplete;
                    }
                }
                // Get all intersection ids
                const allIntersectionIds = [];
                for (let rowPath of PivotChartUtils.getSegmentPaths(design.rows || [])) {
                    for (let columnPath of PivotChartUtils.getSegmentPaths(design.columns || [])) {
                        allIntersectionIds.push(PivotChartUtils.getIntersectionId(rowPath, columnPath));
                    }
                }
                // Add missing intersections
                for (intersectionId of lodash_1.default.difference(allIntersectionIds, lodash_1.default.keys(design.intersections || {}))) {
                    draft.intersections[intersectionId] = {};
                }
                // Remove extra intersections
                for (intersectionId of lodash_1.default.difference(lodash_1.default.keys(design.intersections || {}), allIntersectionIds)) {
                    delete draft.intersections[intersectionId];
                }
                // Clean filter
                draft.filter = exprCleaner.cleanExpr(design.filter ?? null, { table: design.table, types: ["boolean"] });
            }
        });
        // Cache if unchanged (and therefore clean)
        if (design === cleanedDesign) {
            cleanDesignCache.set([design, schema], [], true);
        }
        return cleanedDesign;
    }
    validateDesign(design, schema) {
        let segment;
        const axisBuilder = new AxisBuilder_1.default({ schema });
        // Check that has table
        if (!design.table || !schema.getTable(design.table)) {
            return T `Missing data source`;
        }
        // Check that has rows
        if (design.rows.length === 0) {
            return T `Missing rows`;
        }
        // Check that has columns
        if (design.columns.length === 0) {
            return T `Missing columns`;
        }
        let error = null;
        // Validate axes
        for (segment of PivotChartUtils.getAllSegments(design.rows)) {
            if (segment.valueAxis) {
                error = error || axisBuilder.validateAxis({ axis: segment.valueAxis });
            }
        }
        for (segment of PivotChartUtils.getAllSegments(design.columns)) {
            if (segment.valueAxis) {
                error = error || axisBuilder.validateAxis({ axis: segment.valueAxis });
            }
        }
        for (let intersectionId in design.intersections) {
            const intersection = design.intersections[intersectionId];
            if (intersection.valueAxis) {
                error = error || axisBuilder.validateAxis({ axis: intersection.valueAxis });
            }
            if (intersection.segmentValueAxisOverrides) {
                for (const segmentId of Object.keys(intersection.segmentValueAxisOverrides)) {
                    error = error || axisBuilder.validateAxis({ axis: intersection.segmentValueAxisOverrides[segmentId] });
                }
            }
        }
        return error;
    }
    // Determine if widget is auto-height, which means that a vertical height is not required.
    isAutoHeight() {
        return false;
    }
    isEmpty(design) {
        return !design.table || design.rows.length === 0 || design.columns.length === 0;
    }
    // True if designer should have a preview pane to the left
    hasDesignerPreview() {
        return false;
    }
    // Label for the edit gear dropdown
    getEditLabel() {
        return T `Configure Table`;
    }
    // Creates a design element with specified options
    // options include:
    //   schema: schema to use
    //   dataSource: dataSource to use
    //   design: design
    //   onDesignChange: function
    //   filters: array of filters
    createDesignerElement(options) {
        // Require here to prevent server require problems
        const PivotChartDesignerComponent = require("./PivotChartDesignerComponent").default;
        const props = {
            schema: options.schema,
            dataSource: options.dataSource,
            design: this.cleanDesign(options.design, options.schema),
            filters: options.filter,
            onDesignChange: (design) => {
                // Clean design
                design = this.cleanDesign(design, options.schema);
                return options.onDesignChange(design);
            }
        };
        return react_1.default.createElement(PivotChartDesignerComponent, props);
    }
    /**
     * Get data for the chart asynchronously.
     *
     * @param design - Design of the chart.
     * @param schema - Schema to use.
     * @param dataSource - Data source to get data from.
     * @param filters - Array of { table: table id, jsonql: jsonql condition with {alias} for tableAlias }.
     * @param callback - Callback function to handle the result or error.
     */
    async getData(design, schema, dataSource, filters, callback) {
        try {
            const queryBuilder = new PivotChartQueryBuilder_1.default({ schema });
            const queries = queryBuilder.createQueries(design, filters);
            // Get a list of intersection ids
            const intersectionIds = Object.keys(queries);
            // Get a list of all queries
            const queriesList = intersectionIds.map(intersectionId => queries[intersectionId]);
            // Run queries in parallel
            const results = await Promise.all(queriesList.map((query) => {
                return dataSource.performQuery(query);
            }));
            const data = {};
            // Add results to data
            for (let i = 0; i < queriesList.length; i++) {
                data[intersectionIds[i]] = results[i];
            }
            // Add header and footer data
            const textWidget = new TextWidget_1.default();
            data.header = await new Promise((resolve, reject) => {
                textWidget.getData(design.header, schema, dataSource, filters, (error, headerData) => {
                    if (error) {
                        reject(error);
                    }
                    else {
                        resolve(headerData);
                    }
                });
            });
            data.footer = await new Promise((resolve, reject) => {
                textWidget.getData(design.footer, schema, dataSource, filters, (error, footerData) => {
                    if (error) {
                        reject(error);
                    }
                    else {
                        resolve(footerData);
                    }
                });
            });
            callback(null, data);
        }
        catch (error) {
            callback(error);
        }
    }
    /**
     * Create a view element for the chart
     *
     * @param options - Options for the view element
     * @returns - React element
     */
    createViewElement(options) {
        const PivotChartViewComponent = require("./PivotChartViewComponent").default;
        // Create chart
        const props = {
            schema: options.schema,
            dataSource: options.dataSource,
            design: this.cleanDesign(options.design, options.schema),
            onDesignChange: options.onDesignChange,
            data: options.data,
            width: options.width,
            height: options.height,
            scope: options.scope,
            onScopeChange: options.onScopeChange,
            filters: options.filters
        };
        return react_1.default.createElement(PivotChartViewComponent, props);
    }
    createDropdownItems(design, schema, widgetDataSource, filters) {
        return [];
    }
    createDataTable(design, schema, dataSource, data, locale) {
        // Create layout
        const layout = new PivotChartLayoutBuilder_1.default({ schema }).buildLayout(design, data, locale);
        return lodash_1.default.map(layout.rows, (row) => lodash_1.default.map(row.cells, (cell) => cell.text));
    }
    // Get a list of table ids that can be filtered on
    getFilterableTables(design, schema) {
        let filterableTables = design.table ? [design.table] : [];
        // Add any table overrides from intersections
        for (const intersection of Object.values(design.intersections)) {
            if (intersection.tableOverride) {
                filterableTables.push(intersection.tableOverride);
            }
        }
        // Get filterable tables from header and footer
        const textWidget = new TextWidget_1.default();
        filterableTables = lodash_1.default.union(filterableTables, textWidget.getFilterableTables(design.header, schema));
        filterableTables = lodash_1.default.union(filterableTables, textWidget.getFilterableTables(design.footer, schema));
        // Remove duplicates
        filterableTables = lodash_1.default.uniq(filterableTables);
        return filterableTables;
    }
    // Get the chart placeholder icon. fa-XYZ or glyphicon-XYZ
    getPlaceholderIcon() {
        return "fa-magic";
    }
    translateDesign(design, translate) {
        return (0, immer_1.default)(design, draft => {
            // Helper function to translate a segment and its children
            const translateSegment = (segment) => {
                // Translate segment label
                if (segment.label) {
                    segment.label = translate(segment.label);
                }
                // Translate value axis labels
                if (segment.valueAxis?.categoryLabels) {
                    for (const key in segment.valueAxis.categoryLabels) {
                        segment.valueAxis.categoryLabels[key] = translate(segment.valueAxis.categoryLabels[key]);
                    }
                }
                // Translate null label
                if (segment.valueAxis?.nullLabel) {
                    segment.valueAxis.nullLabel = translate(segment.valueAxis.nullLabel);
                }
                // Recursively translate children
                if (segment.children) {
                    segment.children.forEach(translateSegment);
                }
            };
            // Translate all row segments
            draft.rows.forEach(translateSegment);
            // Translate all column segments
            draft.columns.forEach(translateSegment);
            // Translate all intersections
            for (const intersection of Object.values(draft.intersections)) {
                // Translate value axis labels
                if (intersection.valueAxis?.categoryLabels) {
                    for (const key in intersection.valueAxis.categoryLabels) {
                        intersection.valueAxis.categoryLabels[key] = translate(intersection.valueAxis.categoryLabels[key]);
                    }
                }
                // Translate null label
                if (intersection.valueAxis?.nullLabel) {
                    intersection.valueAxis.nullLabel = translate(intersection.valueAxis.nullLabel);
                }
                // Translate segment value axis override labels
                if (intersection.segmentValueAxisOverrides) {
                    for (const axis of Object.values(intersection.segmentValueAxisOverrides)) {
                        if (axis?.categoryLabels) {
                            for (const key in axis.categoryLabels) {
                                axis.categoryLabels[key] = translate(axis.categoryLabels[key]);
                            }
                        }
                        if (axis?.nullLabel) {
                            axis.nullLabel = translate(axis.nullLabel);
                        }
                    }
                }
            }
            // Translate header and footer using ExprItemsTranslator
            if (draft.header?.items) {
                draft.header.items = (0, ExprItemsTranslator_1.translateHtmlItems)(draft.header.items, translate);
            }
            if (draft.footer?.items) {
                draft.footer.items = (0, ExprItemsTranslator_1.translateHtmlItems)(draft.footer.items, translate);
            }
        });
    }
    // Override to indicate this chart supports XLSX export
    supportsXlsxExport() {
        return true;
    }
    // Creates a SheetJS workbook for the pivot chart data
    createXlsxWorkbook(design, schema, dataSource, data, locale) {
        // Import XLSX here to ensure it's available
        const XLSX = require("xlsx-js-style");
        const Color = require("color");
        // Create a new workbook
        const workbook = XLSX.utils.book_new();
        // Build layout using the layout builder 
        const layoutBuilder = new PivotChartLayoutBuilder_1.default({ schema });
        const layout = layoutBuilder.buildLayout(design, data, locale);
        // Create a 2D array for the worksheet data
        const wsData = [];
        // Process each row in the layout
        layout.rows.forEach(layoutRow => {
            const rowData = [];
            // Process each cell in the row
            layoutRow.cells.forEach(cell => {
                // For skipped cells, still add an empty placeholder
                if (cell.skip) {
                    rowData.push({ v: "", s: {} });
                    return;
                }
                // Create cell value and style
                const cellObj = {
                    v: cell.text === null || cell.text === undefined ? "" : cell.text,
                    s: {}
                };
                // Apply alignment based on cell type and subtype
                if (cell.align === "right") {
                    cellObj.s.alignment = { horizontal: "right" };
                }
                else if (cell.align === "center") {
                    cellObj.s.alignment = { horizontal: "center" };
                }
                else {
                    cellObj.s.alignment = { horizontal: "left" };
                }
                // Apply styles based on cell properties
                if (cell.bold) {
                    cellObj.s.font = { ...cellObj.s.font, bold: true };
                }
                if (cell.italic) {
                    cellObj.s.font = { ...cellObj.s.font, italic: true };
                }
                // Apply background color if present
                if (cell.backgroundColor) {
                    try {
                        const color = Color(cell.backgroundColor);
                        const hex = color.hex().substring(1); // Remove #
                        cellObj.s.fill = {
                            patternType: "solid",
                            fgColor: { rgb: hex },
                            bgColor: { rgb: hex }
                        };
                        // Adjust text color based on background lightness
                        const lightness = color.luminosity();
                        cellObj.s.font = {
                            ...cellObj.s.font,
                            color: { rgb: lightness < 0.3 ? "FFFFFF" : "000000" }
                        };
                    }
                    catch (e) {
                        // Silently ignore color errors
                    }
                }
                // Apply borders
                const borders = {};
                if (cell.borderTop) {
                    const style = cell.borderTop === 1 ? "thin" : cell.borderTop === 2 ? "medium" : "thick";
                    borders.top = { style };
                }
                if (cell.borderBottom) {
                    const style = cell.borderBottom === 1 ? "thin" : cell.borderBottom === 2 ? "medium" : "thick";
                    borders.bottom = { style };
                }
                if (cell.borderLeft) {
                    const style = cell.borderLeft === 1 ? "thin" : cell.borderLeft === 2 ? "medium" : "thick";
                    borders.left = { style };
                }
                if (cell.borderRight) {
                    const style = cell.borderRight === 1 ? "thin" : cell.borderRight === 2 ? "medium" : "thick";
                    borders.right = { style };
                }
                if (Object.keys(borders).length > 0) {
                    cellObj.s.border = borders;
                }
                rowData.push(cellObj);
            });
            wsData.push(rowData);
        });
        // Create a worksheet from the data
        const worksheet = XLSX.utils.aoa_to_sheet(wsData);
        // Process merged cells
        const merges = [];
        // Track current row and column position
        let rowOffset = 0;
        // Traverse layout again to collect merge info
        layout.rows.forEach((layoutRow, rowIndex) => {
            let colOffset = 0;
            layoutRow.cells.forEach((cell, colIndex) => {
                // Skip cells that are part of spans (already handled)
                if (cell.skip) {
                    colOffset++;
                    return;
                }
                // Handle row spans
                if (cell.rowSpan && cell.rowSpan > 1) {
                    merges.push({
                        s: { r: rowOffset, c: colOffset },
                        e: { r: rowOffset + cell.rowSpan - 1, c: colOffset }
                    });
                }
                // Handle column spans
                if (cell.columnSpan && cell.columnSpan > 1) {
                    merges.push({
                        s: { r: rowOffset, c: colOffset },
                        e: { r: rowOffset, c: colOffset + cell.columnSpan - 1 }
                    });
                }
                colOffset++;
            });
            rowOffset++;
        });
        // Apply merges to worksheet
        if (merges.length > 0) {
            worksheet["!merges"] = merges;
        }
        // Set column widths based on content
        const colWidths = [];
        if (wsData.length > 0) {
            for (let colIndex = 0; colIndex < wsData[0].length; colIndex++) {
                // Start with reasonable default width
                let maxWidth = 10;
                // Check all rows for this column
                for (let rowIndex = 0; rowIndex < wsData.length; rowIndex++) {
                    const cell = wsData[rowIndex][colIndex];
                    if (cell && cell.v) {
                        maxWidth = Math.max(maxWidth, String(cell.v).length);
                    }
                }
                // Add some padding and cap at 50 characters
                colWidths.push(Math.min(maxWidth + 2, 50));
            }
            worksheet['!cols'] = colWidths.map(width => ({ wch: width }));
        }
        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, "Pivot Table");
        // Convert workbook to blob
        const workbookBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([workbookBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        return blob;
    }
}
exports.default = PivotChart;
